import { useCallback } from "react";

const STORAGE_KEY = "recentSearchBBT";
const MAX_ITEMS = 4;

export const useRecentSearch = () => {
    const addRecentSearch = useCallback((filterValues) => {
        if (
            !filterValues?.fromCity?.[0] ||
            !filterValues?.toCity?.[0] ||
            !filterValues?.journeyDate
        ) {
            return;
        }

        const newSearch = {
            source: filterValues.fromCity[0],
            destination: filterValues.toCity[0],
            journeyDate: filterValues.journeyDate,
        };

        const existing =
            JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];

        const filtered = existing.filter(
            (s) =>
                s.source.FromCityID !== newSearch.source.FromCityID ||
                s.destination.ToCityID !==
                newSearch.destination.ToCityID
        );

        const updated = [newSearch, ...filtered].slice(0, MAX_ITEMS);

        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(updated)
        );
    }, []);

    const getRecentSearches = useCallback(() => {
        return (
            JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || []
        );
    }, []);

    const clearRecentSearches = useCallback(() => {
        sessionStorage.removeItem(STORAGE_KEY);
    }, []);

    return {
        addRecentSearch,
        getRecentSearches,
        clearRecentSearches,
    };
};
